import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserResponse } from '../../@shared/models/response.module';
import { UserService } from '../../@core/services/user.service';
import { ToastService } from '../../@core/services/toast.service';

@Component({
  selector: 'app-user-profile',
  standalone: false,
  templateUrl: './user-profile.html',
  styleUrl: './user-profile.css'
})
export class UserProfile implements OnInit {
  user: UserResponse;
  selectedTab: string = 'overview';

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.getUser();

    // Check for query parameters
    this.route.queryParams.subscribe(params => {
      if (params['tab']) {
        this.selectedTab = params['tab'];
      }
      // Handle payment cancelled from Stripe checkout
      if (params['payment'] === 'cancelled') {
        this.toastService.info('Payment was cancelled.');
        // Clean up URL but keep tab param
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { tab: params['tab'] || this.selectedTab },
          replaceUrl: true
        });
      }
      // Handle store registration cancelled
      if (params['store_cancelled'] === 'true') {
        this.toastService.info('Store registration was cancelled.');
        // Clean up URL but keep tab param
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { tab: params['tab'] || this.selectedTab },
          replaceUrl: true
        });
      }
    });
  }

  getUser() {
    this.userService.getUser().subscribe((res) => {
      this.user = res.data;
    });
  }
}
